import React, { Component } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from '@material-ui/core';
class AppNavChoose extends Component {
    state = { }

    handleSubmit = (type) => {
        this.props.handleSubmit(type);
    }

    handleClose = () => {
        this.props.handleClose();
    }

    render() {
        const { show, } = this.props;
        return (
            <div>
                <Dialog open={show ? show : false} onClose={this.handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Options To Choose</DialogTitle>
                    <DialogContent dividers>
                        <label>
                            <Button variant="contained" style={{ margin: 4 }} size="small" onClick={() => this.handleSubmit('cy')} color="primary">CY </Button>
                        </label>
                        <label>
                            <Button variant="contained" style={{ margin: 4 }} size="small" onClick={() => this.handleSubmit('branch')} color="primary">BRANCH</Button>                            
                        </label>
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.handleClose} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}
export default AppNavChoose